import { useRecoilValue } from 'recoil';
import { reportDoorState } from '../../../storage/reports';
import DoorStateReportTable from './DoorStateReportTable';

type Props = {
  assetId: string;
};

export function DoorStateReportTableFromAsset({ assetId }: Readonly<Props>) {
  const states = useRecoilValue(reportDoorState(assetId));

  return <DoorStateReportTable states={states} />;
}
